import { RequestOptions } from './request-options';

export class ProductsSpecial extends RequestOptions {
    Name: string;
    IsPersonal: string;
    CategoryName: string;
    Id_CategoryProduct: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/products-special-request-options.ts